import Vue from 'vue'
import App from './App.vue'
import { router, vuetify, i18n } from './plugins'
import { setAuthConfig } from 'ui-common'

const {
  VUE_APP_USER_API_CLIENT_ID,
  VUE_APP_USER_API_CLIENT_SECRET
} = process.env
const clientID = VUE_APP_USER_API_CLIENT_ID
const clientSecret = VUE_APP_USER_API_CLIENT_SECRET

setAuthConfig({
  clientId: +clientID,
  clientSecret: clientSecret
})

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
